import BaseCircleLogo from "./BaseCircleLogo";

export default BaseCircleLogo;
